module.exports = __webpack_public_path__ + "media/images/smart-list-icon-507525c3e2191c2094e7c718fc7d5dd9.svg";